import { render, staticRenderFns } from "./TablesComponent.vue?vue&type=template&id=3546131c&scoped=true"
import script from "./TablesComponent.vue?vue&type=script&lang=js"
export * from "./TablesComponent.vue?vue&type=script&lang=js"
import style0 from "./TablesComponent.vue?vue&type=style&index=0&id=3546131c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3546131c",
  null
  
)

export default component.exports